export interface WorldPayResponse {
  order: {
    orderKey?: string;
    status?: WorldPayOrderStatus;
  };
  error?: string;
  gateway: {
    orderKey?: string;
    mac2?: string;
    paymentCurrency?: string;
    paymentAmount?: string;
    paymentStatus?: WorldPayPaymentStatus;
    mac?: string;
  };
}

export enum WorldPayOrderStatus {
  Success = 'success',
  Cancelled = 'cancelled_by_shopper',
  AlreadyProcessed = 'already_processed',
}

export enum WorldPayPaymentStatus {
  Authorised = 'AUTHORISED',
  Refused = 'REFUSED',
  Error = 'ERROR',
  Hold_Card = 'REFUSED4',
  Refused5 = 'REFUSED5',
  Approve_After_Identification = 'REFUSED8',
  Invalid_Amount = 'REFUSED13',
  Invalid_Card_Issuer = 'REFUSED15',
  Annulation_By_Client = 'REFUSED17',
  Access_Denied = 'REFUSED28',
  Impossible_Reference_Number = 'REFUSED29',
  Card_Expired = 'REFUSED33',
  Fraud_Suspicion = 'REFUSED34',
  Security_Code_Expired = 'REFUSED38',
  Lost_Card = 'REFUSED41',
  Stolen_Card_Pick_Up = 'REFUSED43',
  Limit_Exceeded = 'REFUSED51',
  Invalid_Security_Code = 'REFUSED55',
  Unknown_Card = 'REFUSED56',
  Illegal_Transaction = 'REFUSED57',
  Restricted_Card = 'REFUSED62',
  Security_Rules_Voilated = 'REFUSED63',
  Security_Code_Invalid = 'REFUSED75',
  Card_Blocked = 'REFUSED76',
  Rejected_By_Card_Issuer = 'REFUSED85',
  Revocation_Of_Authorization_Order = 'REFUSEDR1',
  Revocation_Of_All_Authorizations_Order = 'REFUSEDR2',
}
